// extracted by mini-css-extract-plugin
module.exports = {"btn":"edit_btn__3LrcK","select_picture":"edit_select_picture__KVRpr"};